module.exports = __webpack_public_path__ + "img/album14_18.b090b972.jpg";